import React from "react";
import {CircularProgress, Box} from "@mui/material";

export default function LoadingProgress(props) {

    let showIn = props.loading || false
    return (
        <>
            {showIn && (
                <Box sx={{maxWidth: "50px", marginLeft: "auto", marginRight: "auto", marginTop: "50px", marginBottom: "50px"}}>
                    <CircularProgress sx={{ color: 'rgb(80, 70, 228)' }}/>
                </Box>
            )}
        </>
    )
}
